import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import type { ShellOutletContext } from '../../components/shell/AppShell';
import DashboardView from './dashboard-view';

const AppView: React.FC = () => {
  const { user } = useAuth();
  const { searchQuery } = useOutletContext<ShellOutletContext>();
  const fullName = user?.userName?.trim() || 'Account';

  return (
    <DashboardView
      fullName={fullName}
      email={user?.userEmail?.trim() || ''}
      searchQuery={searchQuery}
    />
  );
};

export default AppView;
